import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, Transition as _Transition, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, Teleport as _Teleport, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-086d54af"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "task-parameters-input_search" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "task-parameters-input_search_title" }, "Шаблоны:", -1))
const _hoisted_4 = ["onClick"]
const _hoisted_5 = ["textContent"]
const _hoisted_6 = { class: "task-parameters-input_search_item_parameters" }
const _hoisted_7 = ["textContent"]
const _hoisted_8 = ["onClick"]

import { PopoverPositionEnum, TirPmColorPalette, TirPmInput, TirPmScrollbar } from "tir-components";
import {
  TaskParameterModel,
  TaskParameterTypeEnum,
  TaskParameter,
  getTaskParameterPalette,
  ParametersTemplateModel,
} from "@/components";
import { computed, onMounted, onUnmounted, PropType, ref } from "vue";
import { PlusIcon } from "tir-style-system/icons/outline";
import { PaintIcon } from "tir-style-system/icons/solid";

/**Параметры */

export default /*#__PURE__*/_defineComponent({
  __name: 'task-parameters-input',
  props: {
  /**Тип настройки */
  type: { type: Number as PropType<TaskParameterTypeEnum> },
  /**Демо параметр для поля ввода */
  upsertParameter: {
    type: Object as PropType<TaskParameterModel>,
    default: () => new TaskParameterModel(),
  },
  /**Список параметров текущей сущности */
  currentParameters: { type: Array as PropType<TaskParameterModel[]> },
  /**Список игнорируемых параметров */
  ignoreParameters: { type: Array as PropType<TaskParameterModel[]> },
  /**Список шаблонов */
  templates: { type: Array as PropType<ParametersTemplateModel[]> },
  /**Заголовок параметра */
  title: { type: String, default: "" },
  /**Спрятать вывод шаблонов */
  hideTemplates: { type: Boolean, default: false },
},
  emits: ["update:upsertParameter", "upsert", "selectTemplate"],
  setup(__props, { expose: __expose, emit }) {

const props = __props;


/**События */


/**Сфокусировано ли поле ввода */
const isFocused = ref(false);
/**Элемент обертки */
const $wrapper = ref<HTMLElement>();
/**Стили выпадающего списка */
const dropdownStyle = ref();

/**Общий список параметров шаблонов для поиска */
const templateParameters = computed(() => {
  let parameters = [];
  props.templates?.forEach((template) => {
    parameters.push(...template.ParsedData);
  });
  return parameters;
});
/**Виден ли выпадающий список */
const isDropdownVisible = computed(() => {
  return (
    (!!searchedParameters.value.length || !!searchedTemplates.value.length) &&
    isFocused.value &&
    props.upsertParameter.Name
  );
});
/**Все параметры */
const allParameters = computed(() => {
  const current = props.currentParameters || [];
  const all = [...current, ...templateParameters.value];

  const uniqueParameters = Object.values(
    all.reduce((acc, obj) => ({ ...acc, [obj.Name.toLocaleLowerCase()]: obj }), {}),
  ) as TaskParameterModel[];

  if (!props.ignoreParameters?.length) return uniqueParameters;

  return uniqueParameters.filter(
    (p) =>
      !props.ignoreParameters.some((x) => x.Name.toLocaleLowerCase() == p.Name.toLocaleLowerCase()),
  );
});
/**Найденные параметры */
const searchedParameters = computed(() => {
  const name = props.upsertParameter.Name.toLocaleLowerCase();
  if (!name) return [];
  const searched = allParameters.value.filter((parameter: TaskParameterModel) => {
    return parameter.Name.toLocaleLowerCase().includes(name);
  });
  return searched;
});
/**Найденные шаблоны */
const searchedTemplates = computed(() => {
  const name = props.upsertParameter.Name.toLocaleLowerCase();
  if (!name) return [];
  const searched = props.templates.filter((template) => {
    return (
      template.Name.toLocaleLowerCase().includes(name) ||
      template.ParsedData.some((parameter) => parameter.Name.toLocaleLowerCase().includes(name))
    );
  });
  return searched;
});
/**Обновление компонента по типу */
const label = computed(() => {
  let text = "Введите название ";

  switch (props.type) {
    case TaskParameterTypeEnum.Status:
      text += "статуса";
      break;
    case TaskParameterTypeEnum.Priority:
      text += "приоритета";
      break;
    case TaskParameterTypeEnum.Tag:
      text += "тега";
      break;
    case TaskParameterTypeEnum.Type:
      text += "типа";
      break;
    case TaskParameterTypeEnum.Difficulty:
      text += "сложности";
      break;
  }

  return text;
});
/**Запрещено добавление параметра */
const isCreateDisabled = computed(() => {
  const ignored = props.ignoreParameters || [];
  const parameters = [...ignored, ...searchedParameters.value];
  return parameters.some(
    (p) => p.Name.toLocaleLowerCase() == props.upsertParameter.Name.toLocaleLowerCase(),
  );
});
/**Классы кнопки добавления параметра */
const addButtonClasses = computed(() => ({
  disabled: isCreateDisabled.value,
}));
/**rem единица */
const rem = computed(() => parseFloat(getComputedStyle(document.documentElement).fontSize));

/**После рендра */
onMounted(() => {
  window.addEventListener("resize", setDropdownStyle);
  setTimeout(() => setDropdownStyle());
});
/**Перед удалением компонента */
onUnmounted(() => {
  window.removeEventListener("resize", setDropdownStyle);
});

/**Установка стилей выпадающего списка */
function setDropdownStyle() {
  const rect = $wrapper.value?.getBoundingClientRect();
  if (!rect) return;
  dropdownStyle.value = {
    left: rect.left / rem.value + "rem",
    top: rect.top / rem.value + rect.height / rem.value + 0.5 + "rem",
    width: rect.width / rem.value + "rem",
  };
}
/**Изменить имя параметра */
const updateParameterName = (name: string) => {
  props.upsertParameter.Name = name;
};
/**Изменить цвет параметра */
const updateParameterColor = (color: string) => {
  props.upsertParameter.Color = color;
};
/**Добавление параметра */
const sendParameter = () => {
  if (!props.upsertParameter.Name || isCreateDisabled.value) return;
  emit("upsert", props.upsertParameter);
};
/**Выбор параметра для добавления */
const chooseParameter = (p: TaskParameterModel) => {
  const parameter = new TaskParameterModel(p);
  delete parameter.Id;
  emit("upsert", parameter);
};
/**Установка значения параметра isFocused */
const setIsFocus = (focus: boolean) => {
  isFocused.value = focus;
};
/**Выбор шаблона */
const chooseTemplate = (template: ParametersTemplateModel) => {
  emit("selectTemplate", template);
};

/**Код для использования по ref */
__expose({ setDropdownStyle });

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: "task-parameters-input",
    ref_key: "$wrapper",
    ref: $wrapper
  }, [
    _createVNode(_unref(TirPmInput), {
      "model-value": __props.upsertParameter.Name,
      label: label.value,
      isWithHint: false,
      "onUpdate:modelValue": updateParameterName,
      onEnter: sendParameter,
      onFocus: _cache[0] || (_cache[0] = ($event: any) => (setIsFocus(true))),
      onBlur: _cache[1] || (_cache[1] = ($event: any) => (setIsFocus(false)))
    }, null, 8, ["model-value", "label"]),
    _createVNode(_Transition, { name: "task-parameters-input_animation" }, {
      default: _withCtx(() => [
        (__props.upsertParameter.Name)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              (__props.type != _unref(TaskParameterTypeEnum).Type && !isCreateDisabled.value)
                ? (_openBlock(), _createBlock(_unref(TirPmColorPalette), {
                    key: 0,
                    class: "task-parameters-input_color",
                    "model-value": __props.upsertParameter.Color,
                    position: _unref(PopoverPositionEnum).Bottom,
                    colors: _unref(getTaskParameterPalette)(__props.type),
                    "onUpdate:modelValue": updateParameterColor
                  }, {
                    icon: _withCtx((slot) => [
                      _createElementVNode("div", {
                        class: "task-parameters-input_color_icon",
                        onMousedown: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"]))
                      }, [
                        _createVNode(_unref(PaintIcon), {
                          style: _normalizeStyle({ color: slot.color })
                        }, null, 8, ["style"])
                      ], 32)
                    ]),
                    _: 1
                  }, 8, ["model-value", "position", "colors"]))
                : _createCommentVNode("", true),
              _createElementVNode("div", {
                class: _normalizeClass(["task-parameters-input_icon plus", addButtonClasses.value]),
                onClick: sendParameter
              }, [
                _createVNode(_unref(PlusIcon))
              ], 2)
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
      _createVNode(_Transition, { name: "task-parameters-input_animation" }, {
        default: _withCtx(() => [
          (isDropdownVisible.value)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "task-parameters-input_dropdown",
                style: _normalizeStyle(dropdownStyle.value)
              }, [
                _createVNode(_unref(TirPmScrollbar), null, {
                  default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_2, [
                      (searchedTemplates.value.length && !__props.hideTemplates)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _hoisted_3,
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(searchedTemplates.value, (template) => {
                              return (_openBlock(), _createElementBlock("div", {
                                class: "task-parameters-input_search_item template",
                                onMousedown: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop"])),
                                onClick: ($event: any) => (chooseTemplate(template))
                              }, [
                                _createElementVNode("div", {
                                  textContent: _toDisplayString(template.Name),
                                  class: "task-parameters-input_search_item_template"
                                }, null, 8, _hoisted_5),
                                _createElementVNode("div", _hoisted_6, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(template.ParsedData, (parameter) => {
                                    return (_openBlock(), _createBlock(_unref(TaskParameter), {
                                      preview: "",
                                      type: __props.type,
                                      data: parameter
                                    }, null, 8, ["type", "data"]))
                                  }), 256))
                                ])
                              ], 40, _hoisted_4))
                            }), 256))
                          ], 64))
                        : _createCommentVNode("", true),
                      (searchedParameters.value.length)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                            _createElementVNode("div", {
                              textContent: _toDisplayString(`${__props.title} по названию:`),
                              class: "task-parameters-input_search_title"
                            }, null, 8, _hoisted_7),
                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(searchedParameters.value, (parameter) => {
                              return (_openBlock(), _createElementBlock("div", {
                                class: "task-parameters-input_search_item",
                                onMousedown: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["stop"])),
                                onClick: ($event: any) => (chooseParameter(parameter))
                              }, [
                                _createVNode(_unref(TaskParameter), {
                                  preview: "",
                                  type: __props.type,
                                  data: parameter
                                }, null, 8, ["type", "data"])
                              ], 40, _hoisted_8))
                            }), 256))
                          ], 64))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _: 1
                })
              ], 4))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]))
  ], 512))
}
}

})